<template>
  <div class="main_container">
    <van-nav-bar
    v-show="!$route.params.log_id"
      title="处理信息"
      left-text="返回"
      right-text="完成"
      left-arrow
      :fixed="true"
      @click-left="$router.go(-1)"
      @click-right="postLog"
    />

    <van-nav-bar
    v-show="$route.params.log_id"
      title="处理信息"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="$router.go(-1)"
    />

    <div class="body">      
        <!-- <div class="field">
          <textarea placeholder="请填写处理信息" v-model="log_info.comment"></textarea>
        </div> -->
        <van-cell-group>
          <van-field
            v-model="log_info.comment"
            type="textarea"
            placeholder="请填写处理信息"
            rows="3"
            autosize
            :readonly="$route.params.log_id"
          />
        </van-cell-group>

        <div class="field">
          <van-panel title="照片"  style="text-align: left">
            <van-row>
              <van-col span="6" v-for="(img,idx) in picList" :key="img">
                <div class="van_content" >
                  <div @click="preview(picList,idx)" class="img_file" :style="{backgroundImage:'url(' +img_url+ img + ')'}"></div>
                  <div v-show="editMode" class="edit">
                    <van-icon name="delete" @click="deleteImgConfirm(img)" ></van-icon>
                  </div>
                </div>
              </van-col>
            </van-row>  
            <div slot="footer" v-show="!$route.params.log_id">
              <!-- <van-button @click="takeCamera" size="small">上传照片</van-button> -->
              <van-uploader :after-read="onRead" name="file">
                 <el-button size="mini" type="success">上传照片</el-button>
              </van-uploader>
              <van-button v-show="!editMode && picList.length>0" @click="editMode=true" size="small" type="primary">编辑</van-button>
              <van-button v-show="editMode && picList.length>0" @click="editMode=false" size="small" type="primary">完成</van-button>
            </div>      
          </van-panel>
          
        </div> 

     <!--    处理状态：
        <el-radio-group v-model="log_info.status">
          <el-radio label="init">未处理</el-radio>
          <el-radio label="processing">进行中</el-radio>
          <el-radio label="finished">已解决</el-radio>
        </el-radio-group> -->
        <!-- <el-button v-show="!$route.params.log_id" @click="postLog" type="primary" style="float: right;margin: 30px 10px 0 0">保存</el-button> -->
        <!-- <el-button v-show="$route.params.log_id" @click="updateLog" type="primary" style="float: right;margin: 30px 10px 0 0">更新</el-button> -->
    </div>
  </div>
</template>

<script>
import { ImagePreview,Dialog,Toast  } from 'vant';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      picList:[],
      img_url:'http://jnwzhuabei2.oss-cn-beijing.aliyuncs.com/alarm_log_img/',
      editMode:false,
      dialogImageUrl: '',
      dialogVisible: false,
      alarm_id:'',
      log_id:'',
      log_info:{
        status:'init',
        comment:'',
        pic:''
      },
      alarm_id:'',
      log_id:''
    }
  },
  computed:{

  },
  mounted(){
    var alarm_id = this.$route.params.id
    var log_id = this.$route.params.log_id
    if (log_id){
      this.getLogInfo()
    }
  },
  methods:{
    onSuccess(file){
      var self = this
      this.axios_base.post("alarm/uploadImgOrd", {content:'data:image/png;base64,'+file}).then(function(resp){
        if (resp){
          self.picList.push(resp.data)
        }
      })
    },
    takeCamera(){
      navigator.camera.getPicture(this.onSuccess, function(err){
        console.log(err)
      },
      { 
        quality: 25,
        destinationType: Camera.DestinationType.DATA_URL
      });
    },
    getLogInfo(){
      var self = this
      this.axios_base.get('alarm/getSingleLog?log_id='+this.$route.params.log_id).then(function(resp){
        self.log_info = resp.data[0]
        if (self.log_info.pic){
          self.picList = self.log_info.pic.split(',')  
        }
      })
    },
    chooseImg(){
      var self = this
      wx.chooseImage({
        count: 9, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album','camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res) {
          var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          self.upLoadImg(localIds)
        }
      });
    },
    imgStrToList(img_str){
      if (img_str){
        var img_list = img_str.split(',')
        return img_list
      }else{
        return ''
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      alert('remove')
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    preview(imgList,idx){
      this.showRebuildBt = true
      var preview_list = []
      for (var i in imgList){
        preview_list.push(this.img_url + imgList[i])
      }
      ImagePreview(preview_list, idx);
    },
    deleteImgConfirm(img){
      var self = this
      Dialog.confirm({
        title: '确定删除图片？',
        // message: '弹窗内容'
      }).then(() => {
        var index = self.picList.indexOf(img);
        if (index > -1) {
          self.picList.splice(index, 1);
        }
      }).catch(() => {
        console.log('cancel')
      });
    },
    onRead(file) {
      console.log(file)
      var self = this
      this.axios_base.post("alarm/uploadImgOrd", file).then(function(resp){
        if (resp){
          self.picList.push(resp.data)
        }
      })
    },
    postLog(){
      var self = this
      var pic = this.picList.join(',')
      this.log_info.pic = pic
      this.log_info.task_id = this.$route.params.id
      this.axios_base.post('alarm_token/postLog',{data:this.log_info}).then(function(resp){
        // self.$router.push({name:'deal_log',params:{id:self.log_info.task_id, log_id: resp.data.id}})
        self.$router.go(-1)
      })
    },
    updateLog(){
      var self = this
      var pic = this.picList.join(',')
      this.log_info.pic = pic
      this.axios_base.post('alarm/UpdateLog',{data:this.log_info, log_id:this.$route.params.log_id}).then(function(resp){
        
        self.getLogInfo()

        Toast.success('更新成功');
        self.$router.go(-1)
      }).catch(function(e){
        Toast.fail('错误'+e);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content{
  max-width: 100%;
  margin: 20px auto 0 auto ;
}
.img_container{
  height: 110px;
  width: 70%;
  margin:10px auto 0px auto;
  text-align: left;
}
.img_li{
  display: inline-block;
  height: 80px;
  float: left;
  width: 50%
}

.img_file{
  display: inline-block;
  height: 80px;
  width: 80px;
  background-position:center;
  background-repeat:no-repeat;
  background-size:80px auto;
  border-radius: 5px;
  margin:5px 5px 0 5px ;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/alarm/dealAlarm.vue